module.exports = __webpack_public_path__ + "media/images/lb/581-212e06489e926ca946a3788522b8dea2.svg";